// API Configuration
// Production must always use the same public domain as the frontend.
// This prevents an old REACT_APP_API_URL from forcing localhost in the VPS build.
const isLocalBrowser =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const API_URL = isLocalBrowser
  ? (process.env.REACT_APP_API_URL || "http://localhost:3010/api")
  : "/api";

export const API = API_URL;
